import { BannerId } from '../../../typings/banners';
import { InternalResourceId } from '../../../typings/internalBanners';

export const DUPLICATE_INTERNAL_BANNER_IMAGE = 'DUPLICATE_INTERNAL_BANNER_IMAGE';
export type DUPLICATE_INTERNAL_BANNER_IMAGE = typeof DUPLICATE_INTERNAL_BANNER_IMAGE;
export interface DuplicateInternalBannerImage {
    type: DUPLICATE_INTERNAL_BANNER_IMAGE;
    bannerId: BannerId;
    newBannerId: BannerId;
    resourceId: InternalResourceId;
}

export function duplicateInternalBannerImageAction(
    bannerId: BannerId,
    newBannerId: BannerId,
    resourceId: InternalResourceId
): DuplicateInternalBannerImage {
    return {
        type: DUPLICATE_INTERNAL_BANNER_IMAGE,
        bannerId,
        newBannerId,
        resourceId
    };
}
